/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMInstrumentation
 */

'use strict';

var ReactDOMDebugTool = require('./ReactDOMDebugTool');

module.exports = { debugTool: ReactDOMDebugTool };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react/lib/ReactDOMInstrumentation.js
 ** module id = 134
 ** module chunks = 0 1 2 3 4 5 6 7
 **/